import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils'

import { UrlParams } from 'Portals/Supplier/constants'
import { SiteVisit } from 'Portals/Supplier/entities'
import { getFilterConfig } from 'Portals/Supplier/Pages/SiteVisit/TableList/Filters/utils/config'
import { SiteVisitRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

const STORAGE_SITE_VISIT_PAGE_SIZE = storagePageSizeConstant('siteVisit')

export class SiteVisitTable extends TableStore<SiteVisit.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_SITE_VISIT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: SiteVisitRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		this.initFilterParamsFromUrl(params, [UrlParams.supplierLocationId], getFilterConfig())
	}

	reset = () => {
		this.resetTable()
	}
}
